<template>
  <div class="home">
    <div class="dangload-box" v-show="shows">
      <div class="dangload">
        <img src="./img/guanbi.png" class="guanbi" @click="gauanbi()">
        <div>
          <img src="./img/xiexie.png">
          <p>感谢您的反馈！<br>祝您生活愉快。</p>
        </div>
      </div>
    </div>
    <div class="title"><img src="./img/logo.png"></div>
    <div class="thank">
      <!-- <img src="./img/调查问卷.png" alt=""> -->
      <div><img src="./img/diaocha.png" class="img1"></div>
      <div class="xiexie">谢谢您参与!</div>
      <div class="FK">可以再花几秒钟提供您的反馈吗？【5分最高,1分最低】</div>
    </div>
    <div class="one">
      <div class="one-title" :class="this.value1 === undefined ? 'one-title' : 'one-title-true'">
        1.您对本篇内容的整体满意度如何？【5分最高,1分最低】</div>
      <div class="start-box">
        <i class="iconfont i-start" v-for="n in max" :class="n <= value1 ? 'i-start' : 'i-start-empty'" :key="n"
          @click="handleClick(n)"></i>
      </div>
      <div class="start-text">
        <span>有待改进</span>
        <span>一般</span>
        <span>还可以</span>
        <span>不错</span>
        <span>非常好</span>
      </div>
    </div>
    <div class="one">
      <div class="one-title">2.您对本篇内容涉及项目领域的满意度如何？【5分最高,1分最低】</div>
      <div class="start-box">
        <i class="iconfont i-start" v-for="n in max" :class="n <= value2 ? 'i-start' : 'i-start-empty'" :key="n"
          @click="handleClick2(n)"></i>
      </div>
      <div class="start-text">
        <span>有待改进</span>
        <span>一般</span>
        <span>还可以</span>
        <span>不错</span>
        <span>非常好</span>
      </div>
    </div>
    <div class="one">
      <div class="one-title">3.您对本篇文案内容的满意度如何？【5分最高,1分最低】</div>
      <div class="start-box">
        <i class="iconfont i-start" v-for="n in max" :class="n <= value3 ? 'i-start' : 'i-start-empty'" :key="n"
          @click="handleClick3(n)"></i>
      </div>
      <div class="start-text">
        <span>有待改进</span>
        <span>一般</span>
        <span>还可以</span>
        <span>不错</span>
        <span>非常好</span>
      </div>
    </div>
    <div class="one">
      <div class="one-title">4.您对本篇内容设计排版的满意度如何？【5分最高,1分最低】</div>
      <div class="start-box">
        <i class="iconfont i-start" v-for="n in max" :class="n <= value4 ? 'i-start' : 'i-start-empty'" :key="n"
          @click="handleClick4(n)"></i>
      </div>
      <div class="start-text">
        <span>有待改进</span>
        <span>一般</span>
        <span>还可以</span>
        <span>不错</span>
        <span>非常好</span>
      </div>
    </div>
    <div class="one">
      <div class="one-title">5.您的宝贵建议：</div>
      <div class="textaarea-box"><textarea name="" id="" cols="30" rows="10" placeholder="非常想听到您的建议，请您说说吧"
          v-model="list"></textarea>
      </div>
    </div>
    <div class="submit-box"><button class="submit" @click="handleSubmit()">提交</button></div>
    <div class="bottom-text">感谢您抽出宝贵的时间参与小调查！</div>
  </div>
</template>

<script>
// import HelloWorld from "../components/HelloWorld.vue";
import axios from 'axios';
import { Dialog } from 'vant';
import md5 from 'js-md5';
export default {
  name: 'HomeView',
  data() {
    return {
      max: 5,
      value1: 0,
      value2: 0,
      value3: 0,
      value4: 0,
      list: "",
      shows: false,
      pid: ''
    }
  },
  beforeCreate() {
    this.value1 = 0
  },
  created() {
    let time = parseInt(new Date().getTime()) + '';
    if (this.$route.query.param != "") {
      // let uids = localStorage.getItem('uid')
      // if (uids == '' || uids == undefined) {
      //   let uid = md5(this.$route.query.param + time)
      //   localStorage.setItem('uid', uid)
      //   this.pid = uid
      // } else {
      //   this.pid = uids
      // }
      this.pid = md5(this.$route.query.param + time)
    }
    this.value1 = this.$route.query.q1
    if (this.$route.query.q1 != '') {
      axios.post('https://ecare.unicef.cn/api/survey/emailAddSatisfaction', { Q1: this.value1, param: this.$route.query.param, uid: this.pid, utm_campaign: this.$route.query.utm_campaign });
    }
  },
  methods: {
    handleClick(n) {
      // n = this.value;
      this.value1 = n;
      axios.post('https://ecare.unicef.cn/api/survey/emailAddSatisfaction', { Q1: this.value1, param: this.$route.query.param, uid: this.pid, utm_campaign: this.$route.query.utm_campaign });
    },
    handleClick2(n) {
      // n = this.value;
      this.value2 = n;
      axios.post('https://ecare.unicef.cn/api/survey/emailAddSatisfaction', { Q2: this.value2, param: this.$route.query.param, uid: this.pid, utm_campaign: this.$route.query.utm_campaign });
    },
    handleClick3(n) {
      // n = this.value;
      this.value3 = n;
      axios.post('https://ecare.unicef.cn/api/survey/emailAddSatisfaction', { Q3: this.value3, param: this.$route.query.param, uid: this.pid, utm_campaign: this.$route.query.utm_campaign });
    },
    handleClick4(n) {
      // n = this.value;=
      this.value4 = n;
      axios.post('https://ecare.unicef.cn/api/survey/emailAddSatisfaction', { Q4: this.value4, param: this.$route.query.param, uid: this.pid, utm_campaign: this.$route.query.utm_campaign });
    },
    handleSubmit() {
      let data = {
        param: this.$route.query.param,
        Q1: this.value1,
        Q2: this.value2,
        Q3: this.value3,
        Q4: this.value4,
        recom: this.list,
        uid: this.pid,
        utm_campaign: this.$route.query.utm_campaign
      }
      axios.post(`https://ecare.unicef.cn/api/survey/emailAddSatisfaction`, data).then(res => {
        if (res.data.code == 200) {
          this.shows = true;
        } else {
          Dialog({
            title: '温馨提示',
            message: res.data.msg,
          }).then(() => {
            // on close
          });
        }
      });
    },
    gauanbi() {
      this.shows = false;
      history.back();
      window.open("", "_self");
      localStorage.removeItem('uid')
      window.close()
    },
  },
}
</script>
<style lang="scss">
.van-dialog {
  width: 600px !important;

  .van-dialog__header {
    font-size: 24px !important;
    font-family: 'FZLTHT' !important;
  }

  .van-dialog__message--has-title {
    padding-top: 30px;
    font-size: 16px;
    font-family: 'FZLTJT';
    color: #333;
  }

  .van-button__text {
    color: #1cabe2;
  }
}

@font-face {
  font-family: "FZLTHT";
  src: url("./font/FZLTCHJW.TTF");
}

@font-face {
  font-family: "FZLTJT";
  src: url("./font/FZLTHJW.TTF");
}

* {
  font-family: "FZLTHT";
  color: #333;
}

.one-title-true {
  color: #1cabe2;
}

body {
  background-color: #e9f6fc;
  touch-action: manipulation;
}

.title {
  height: 100px;
  width: 100%;
  background-color: #1cabe2;
  display: flex;
  align-items: center;

  img {
    margin-left: 20px;
    width: 240px;
  }
}

.thank {
  width: 1170px;
  height: 345px;
  margin: 0 auto;
  background-color: white;
  border-radius: 20px;
  margin-top: 200px;
  text-align: center;
  position: relative;

  .img1 {
    position: absolute;
    left: 50%;
    top: -80px;
    margin-left: -140px;
    width: 245px;
  }
}

.xiexie {
  display: inline-block;
  margin-top: 120px;
  font-size: 60px;
  color: #1cabe2;
}

.FK {
  font-size: 24px;
  font-family: 'FZLTJT';
  margin-top: 40px;
  margin-bottom: 200px;
}

.one {
  width: 1170px;
  height: 345px;
  margin: 0 auto;
  background-color: white;
  border-radius: 20px;
  margin-top: 40px;
  font-size: 24px;

  .one-title {
    margin-left: 40px;
    margin-top: 40px;
    display: inline-block;
  }
}

.submit {
  width: 145px;
  height: 47px;
  background-color: #ff7200;
  border: none;
  font-size: 24px;
  color: white;
  border-radius: 5px;
  cursor: pointer;
}

.submit-box {
  text-align: center;
  margin-top: 80px;
}

.i-start {
  display: inline-block;
  width: 95px;
  height: 95px;
  background-image: url(./img/xingxingtwo.png);
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}

.i-start-empty {
  display: inline-block;
  width: 95px;
  height: 95px;
  background-image: url(./img/xingxingone.png);
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
  cursor: pointer;
}

.start-box {
  padding: 0px 150px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 50px;
}

.start-text {
  padding: 0px 150px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  span {
    margin-top: 45px;
    display: inline-block;
    width: 96px;
    font-size: 24px;
    text-align: center;
  }
}

.textaarea-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;

  textarea {
    outline: none;
    padding: 20px 10px;
    width: 90%;
    height: 180px;
    resize: none;
    border: 2px solid #1cabe2;
    border-radius: 7px;
    font-size: 20px;
    font-family: "FZLTJT";
  }
}

.bottom-text {
  font-size: 32px;
  color: #333;
  text-align: center;
  margin-top: 55px;
  font-family: "FZLTJT";
}

.bottom-text {
  margin-bottom: 40px;
}

.dangload {
  font-size: 40px;
  width: 612px;
  height: 506px;
  background-color: white;
  display: inline-block;
  border-radius: 20px;
  display: -webkit-box;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  position: relative;

  img {
    width: 240px;
    height: 240px;
  }

  p {
    color: #1cabe2;
  }

  .guanbi {
    position: absolute;
    width: 30px;
    height: 30px;
    right: 35px;
    top: 35px;
    cursor: pointer;
  }
}

.dangload-box {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  background-color: rgba($color: #000000, $alpha: 0.5)
}

@media screen and (max-width: 1300px) {
  .thank {
    width: 90%;
    height: 200px;

    .img1 {
      width: 170px;
      margin-left: -85px;
    }
  }

  .xiexie {
    margin-top: 70px;
    font-size: 30px;
  }

  .FK {
    font-size: 16px;
    margin-top: 20px;
  }

  .one {
    width: 90%;
    height: 200px;

    .one-title {
      font-size: 16px;
      margin-top: 20px;
      margin-left: 20px;
    }

    .i-start {
      width: 60px;
      height: 60px;
    }

    .i-start-empty {
      width: 60px;
      height: 60px;
    }

    .start-box {
      padding: 0 30px;
      margin-top: 20px;
    }

    .start-text {
      padding: 0 30px;
      margin-top: 20px;

      span {
        width: 60px;
        font-size: 14px;
        margin-top: 0px;
      }
    }
  }

  .textaarea-box {
    textarea {
      width: 90%;
      height: 90px;
      font-size: 16px;
      padding: 10px 10px;
    }
  }

  .submit-box {
    margin-top: 30px;

    .submit {
      width: 120px;
      height: 40px;
      font-size: 20px;
    }
  }

  .submit-box:hover {
    cursor: pointer;
  }

  .bottom-text {
    margin-bottom: 40px;
    font-size: 24px;
    margin-top: 30px;
  }
}

@media screen and (max-width: 450px) {
  .xiexie {
    margin-top: 60px;
    font-family: "方正兰亭黑粗体";
  }

  .title {
    height: 50px;

    img {
      width: 130px;
    }
  }

  .thank {
    margin-top: 120px;
    height: 200px;
  }

  .FK {
    padding: 0 10px;
    font-size: 18px;
    text-align: left;
  }

  .one {
    width: 90%;
    height: 200px;

    .one-title {
      font-size: 17px;
      margin-top: 20px;
      margin-left: 10px;
      margin-right: 10px;
    }

    .i-start {
      width: 55px;
      height: 55px;
    }

    .i-start-empty {
      width: 55px;
      height: 55px;
    }

    .start-box {
      padding: 0 20px;
      margin-top: 20px;
    }

    .start-text {
      padding: 0 20px;
      margin-top: 0px;

      span {
        width: 55px;
        font-size: 13px;
        margin-top: 20px;
      }
    }
  }

  .textaarea-box {
    margin-top: 10px;

    textarea {
      width: 85%;
      height: 110px;
      font-size: 14px;
    }
  }

  .submit-box {
    .submit {
      width: 110px;
      height: 40px;
      font-size: 16px;
      border-radius: 5px;
    }
  }

  .bottom-text {
    margin-top: 20px;
    font-size: 16px;
    margin-bottom: 40px;
  }

  .dangload {
    font-size: 20px;
    width: 90%;
    height: 240px;
    background-color: white;
    display: inline-block;
    border-radius: 20px;
    display: -webkit-box;
    -webkit-box-pack: center;
    -webkit-box-align: center;
    position: relative;

    img {
      width: 120px;
      height: 120px;
    }

    p {
      color: #1cabe2;
    }

    .guanbi {
      position: absolute;
      width: 20px;
      height: 20px;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
  }

  .van-dialog {
    width: 320px !important;

    .van-dialog__header {
      font-size: 24px !important;
      font-family: 'FZLTHT' !important;
    }

    .van-dialog__message--has-title {
      padding-top: 30px;
      font-size: 16px;
      font-family: 'FZLTJT';
      color: #333;
    }

    .van-button__text {
      color: #1cabe2;
    }
  }
}

.dangload {
  background-image: url(./img/background.png);
  background-size: cover;
}

// @media screen and (max-width: 1300px) {
//   .start-box{
//     padding: 0px 100px;
//   }
//   .start-text{
//     padding: 0px 100px;
//   }
// }</style>
